import {GET_FILE_UPLOAD} from 'api/ApiConstants.js';

export const getLogoUrl = (filename) => {
    let url = GET_FILE_UPLOAD +'?type=AGENT_LOGO&fileName='+filename;
    return url;
}